import { render } from "./CreateWorkManagementForm.vue?vue&type=template&id=d8ab7222"
import script from "./CreateWorkManagementForm.vue?vue&type=script&lang=ts"
export * from "./CreateWorkManagementForm.vue?vue&type=script&lang=ts"
script.render = render

export default script